import { render, staticRenderFns } from "./CuButton.vue?vue&type=template&id=96319642&scoped=true"
import script from "./CuButton.vue?vue&type=script&lang=js"
export * from "./CuButton.vue?vue&type=script&lang=js"
import style0 from "./CuButton.vue?vue&type=style&index=0&id=96319642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96319642",
  null
  
)

export default component.exports